export const DESK_CHANNEL = 'namibiago-desk';

/** Tells the other tabs of this browser that the desk was wiped, so they
 * drop their in-memory copies too (DeskProvider listens). */
export function broadcastDeskWiped(): void {
  if (typeof BroadcastChannel === 'undefined') return;
  const channel = new BroadcastChannel(DESK_CHANNEL);
  channel.postMessage('wiped');
  channel.close();
}
